import React from 'react';

const ManageAllOrders = () => {
    return (
        <div>
            Manage order page
        </div>
    );
};

export default ManageAllOrders;